var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.exibirIcone)?_c('icone-tooltip',{attrs:{"icone":_vm.configuracao.icone,"texto":_vm.configuracao.texto,"cor":"grey","tamanho":(_vm.tamanhoIcone + "px")}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }